const DEFAULT_ITEMS = [
  "Direct Taxation",
  "GST & Indirect Taxation",
  "Audit & Assurance",
  "Startup Advisory",
  "NRI Taxation",
  "Virtual CFO",
  "RERA Compliance",
  "FEMA Advisory",
  "Accounting & MIS",
  "Corporate Compliance",
];

export const Marquee = ({ items = DEFAULT_ITEMS }) => {
  const row = [...items, ...items];
  return (
    <div
      className="overflow-hidden border-y border-slate-200 bg-slate-50 py-5"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-display text-xl md:text-2xl text-navy/80 italic">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-corpblue/60" />
          </span>
        ))}
      </div>
    </div>
  );
};
